import UpsellStep from '@screens/configuration/upsell'

export default function UpsellStepPage() {
  return <UpsellStep />
}
